import { render, staticRenderFns } from "./WSwitch.vue?vue&type=template&id=6486a7fa&"
import script from "./WSwitch.vue?vue&type=script&lang=js&"
export * from "./WSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports